import React from 'react';
import { IBestDataset } from '../../../../../types/analytics';
import { IEnrichedMetadata } from '../../../../../types/metadata';
import { IAnalytcisUserInput } from '../../../../../types/IAnalyticsUserInput';
import { MarkerItem } from '../../../../../types/home';
import { TabKey } from '../../../../../utils/common';
import { IAdvancedAnalyticsApiPayload } from '../../../../../types/chart';
import Exceedance from '../Plot/Exceedance/Exceedance';

interface ExceedanceBoxProps {
  activePlotAnalytics: string | null;
  updating: boolean;
  previewDatasetId: string;
  coordinates: number[];
  datasets: IBestDataset[];
  dateRange: any;
  enrichedMetadata: IEnrichedMetadata[];
  onUpdate: (payload: IAdvancedAnalyticsApiPayload) => void;
  exceedanceValuesImage: string;
  exceedanceValuesLinks: string[];
  error: string;
  pointName: string;
  userInput: IAnalytcisUserInput;
  updateUserInput: (update: Partial<IAnalytcisUserInput>) => void;
  onDatasetChange: (value: string) => void;
  point?: MarkerItem;
  onChangeActiveKey: (item: any, key?: TabKey) => void;
  pointOption: { label: string; value: string }[];
  isForAllAnalytics: boolean;
  setIsForAllAnalytics: (value: boolean) => void;
  isOfflineDataset: boolean;
  globalDateRange: any[];
  setGlobalDateRange: (value: any[]) => void;
}

const ExceedanceBox: React.FC<ExceedanceBoxProps> = ({
  activePlotAnalytics,
  updating,
  previewDatasetId,
  coordinates,
  datasets,
  dateRange,
  enrichedMetadata,
  onUpdate,
  exceedanceValuesImage,
  exceedanceValuesLinks,
  error,
  pointName,
  userInput,
  updateUserInput,
  onDatasetChange,
  point,
  onChangeActiveKey,
  pointOption,
  isForAllAnalytics,
  setIsForAllAnalytics,
  globalDateRange,
  setGlobalDateRange,
  isOfflineDataset,
}) => {
  if (activePlotAnalytics !== 'Exceedance') {
    return null;
  }

  return (
    <Exceedance
      updating={updating}
      previewDatasetId={previewDatasetId}
      coordinates={coordinates}
      datasets={datasets}
      dateRange={dateRange}
      enrichedMetadata={enrichedMetadata}
      onUpdate={onUpdate}
      exceedanceValuesImage={exceedanceValuesImage}
      exceedanceValuesLinks={exceedanceValuesLinks}
      error={error}
      pointName={pointName}
      userInput={userInput}
      updateUserInput={updateUserInput}
      onDatasetChange={onDatasetChange}
      point={point}
      onChangeActiveKey={onChangeActiveKey}
      pointOption={pointOption}
      isForAllAnalytics={isForAllAnalytics}
      setIsForAllAnalytics={setIsForAllAnalytics}
      globalDateRange={globalDateRange}
      setGlobalDateRange={setGlobalDateRange}
      isOfflineDataset={isOfflineDataset}
    />
  );
};

export default ExceedanceBox;
